export default __webpack_public_path__ + "static/media/sexy_banner_highlight.6c891d42.png";